import req from '../../api/request'
import type { Roster } from '../../types/Roster'

/**
 * GET /teams/:teamId/rosters — every roster of the team, one per season (root
 * schedule), in the server's order (most recent first). `view`-gated.
 *
 * The payload names a roster by `uid`; it is exposed as `id` too, so a roster
 * reads the same as every other roster-keyed source (balance discovery, the
 * Player Finder settings' `roster_id`).
 */
export const getTeamRosters = async (teamId: string): Promise<Roster[]> => {
  const data: Roster[] = await req(`/teams/${teamId}/rosters`)

  return (data ?? []).map((roster) => ({ ...roster, id: roster.uid }))
}
